
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freelance-talent",
      function () {
        return require("private-next-pages/freelance-talent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freelance-talent"])
      });
    }
  